import { requestGet } from '../utils/request';

const BASE_URL = '/api/v4/fields/';

/**
 * Get Field Data
 * @param {String} fieldId
 * @return {Promise} Response
 */
export function requestField(fieldId) {
  return requestGet(`${BASE_URL}${fieldId}?includeBoundary=true`, {
    mockFile: 'field/default',
  });
}
